export * from "-!../node_modules/babel-loader/lib/index.js!../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=93f016b8&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=93f016b8&
// module id = 860
// module chunks = 0